<template>
  <settings-page-layout
      :is-loading="isLoading"
      toolbar-title="pages.launcher.versions.title"
      :progress-bar-loading="isLoading === 'versions'"
      :toolbar-buttons="toolbarButtons">

    <v-card
        elevation="2"
    >
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left" style="width:50%">
              {{ $t('pages.launcher.versions.headers.name') }}
            </th>
            <th class="text-left">
              {{ $t('pages.launcher.versions.headers.created') }}
            </th>
            <th class="text-left">
              {{ $t('pages.launcher.versions.headers.branches') }}
            </th>
            <th class="text-right">
              {{ $t('pages.launcher.versions.headers.actions') }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-ripple
              v-for="(item, index) in versions"
              :key="index"
              @click.prevent="editVersion(item.id)"
              style="cursor: pointer;user-select: none"
          >
            <td>{{ item.name }}</td>
            <td>{{  dateTimeFormatter.format(new Date(item.creation)) }}</td>
            <td>{{ item.branches.map(b => b.name).join(', ') }}</td>
            <td class="align-end">
              <v-row align="end">
                <v-col class="text-right">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          icon
                          @click.stop="editVersion(item.id)"
                          :disabled="isLoading != null"
                          v-on="on"
                          v-bind="attrs">
                        <v-icon
                            small>
                          mdi-cog
                        </v-icon>
                      </v-btn>
                    </template>

                    <span>{{ $t('pages.launcher.versions.buttons.edit') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          icon
                          @click.stop="deleteVersion(item.id)"
                          :disabled="isLoading != null"
                          :loading="isLoading === 'delete' && selected === item.id"
                          v-on="on"
                          v-bind="attrs">
                        <v-icon
                            small>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>

                    <span>{{ $t('pages.launcher.versions.buttons.delete') }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </settings-page-layout>
</template>

<script>
import SettingsPageLayout from "@/components/SettingsPageLayout";
import {AlertService} from "@/services/AlertService";
import {LauncherService} from "@/services/LauncherService";
import FormatService from "@/services/FormatService";
import {DialogService} from "@/services/DialogService";

export default {
  name: "LauncherVersionsView",
  components: {SettingsPageLayout},
  data() {
    return {
      isLoading: null,
      selected: null,

      toolbarButtons: [
        {
          isDisabled: l => l != null,
          isLoading: () => false,
          onClick: this.createVersion,
          icon: 'mdi-package-variant-closed',
          text: 'pages.launcher.versions.toolbar.createVersion'
        },
        {
          isDisabled: l => l != null,
          isLoading: l => l === 'versions',
          onClick: this.loadVersions,
          icon: 'mdi-refresh',
          text: 'pages.launcher.versions.toolbar.refresh'
        }
      ],

      dateTimeFormatter: FormatService.dateTimeFormatter,

      versions: []
    }
  },

  methods: {
    loadVersions(){
      this.isLoading = 'versions'
      AlertService.clearAlert();
      LauncherService.getVersions().then(versions => {
        this.$log.info('Loaded versions:',versions)
        this.versions = versions
      }).catch(() => {
        AlertService.displayAlert('error', 'pages.launcher.versions.messages.failedToLoad', 0)
      }).finally(() => {
        this.isLoading = null;
      })
    },
    createVersion(){
      this.$router.push('/launcher/versions/create');
    },
    editVersion(versionId){
      if(this.isLoading != null) return;

      this.$log.debug('Edit version:',versionId)

      this.$router.push(`/launcher/versions/edit/${versionId}`)
    },
    deleteVersion(versionId){
      this.$log.debug('Delete version:',versionId)
      DialogService.addDialog({
        title: 'pages.launcher.versions.deleteDialog.title',
        text: 'pages.launcher.versions.deleteDialog.text',
        width: 400,
        buttons: [
          {
            text: 'pages.launcher.versions.deleteDialog.buttons.cancel',
            color: 'secondary'
          },
          {
            text: 'pages.launcher.versions.deleteDialog.buttons.delete',
            color: 'primary'
          }
        ]
      }).then(res => {
        if(res !== 1) return;

        this.selected = versionId;
        this.isLoading = 'delete';
        AlertService.clearAlert();
        LauncherService.deleteVersion(versionId).then(res => {
          this.$router.push(`/progress/${res.progressId}`);
        }).catch(() => {
          AlertService.displayAlert('error', 'pages.launcher.versions.messages.failedToDelete', 2000)
          this.isLoading = null
        })
      })
    }
  },

  mounted() {
    this.loadVersions();
  }
}
</script>

<style scoped>

</style>